import { render, staticRenderFns } from "./STextareaAutosize.vue?vue&type=template&id=b43f1bae"
import script from "./STextareaAutosize.vue?vue&type=script&lang=js"
export * from "./STextareaAutosize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports